import { render } from "./athWyCho.vue?vue&type=template&id=5e3bdcd5"
import script from "./athWyCho.vue?vue&type=script&lang=js"
export * from "./athWyCho.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__